<div [class.collapsed]="sideNav.isCollapsed" class="sidenav d-flex flex-column">
	<div class="header d-flex align-items-center">
		<a routerLink="/" class="logo position-relative">
			<img class="logo-img logo-full" src="assets/Dixon-logo-website.png" alt="dixon logo" />
			<img class="logo-img logo-sm" src="assets/dixon-logo-small.png" alt="dixon logo" />
		</a>
		<button (click)="sideNav.toggleCollapsed()" mat-icon-button class="toggle" aria-label="Toggle navigation panel">
			<mat-icon>chevron_left</mat-icon>
		</button>
	</div>

	@let vm = clientVm | async;
	<div class="d-flex flex-grow-1 min-h-0 sidenav-body">
		<div class="tool-rail overflow-y-auto overflow-x-hidden d-flex flex-column py-2">
			<div class="d-flex flex-column flex-grow-1">
				@if (vm?.visibleTools; as visibleTools) {
					@for (tool of visibleTools; track tool.tool) {
						<button
							type="button"
							class="tool d-flex flex-column align-items-center w-100 p-0 my-2 border-0 bg-transparent"
							(click)="onToolClick(tool.tool)"
						>
							<span
								class="icon d-flex align-items-center justify-content-center"
								[class.selected]="isToolSelected(tool.tool)"
							>
								<mat-icon>{{ tool.icon }}</mat-icon>
							</span>
							<span class="tool-label">{{ tool.label }}</span>
						</button>
					}
				}
			</div>

			@if (currentUser$ | async; as currentUser) {
				<div class="profile d-flex justify-content-center py-2 mt-2">
					<button
						type="button"
						mat-icon-button
						class="p-0"
						[matMenuTriggerFor]="menu"
						(click)="$event.stopPropagation()"
					>
						<dix-avatar [identifier]="currentUser.id" [name]="currentUser.firstName" size="medium"></dix-avatar>
					</button>
					<mat-menu #menu="matMenu" yPosition="above" xPosition="after">
						<div class="profile-menu-header d-flex align-items-center p-3" (click)="$event.stopPropagation()">
							<dix-avatar [identifier]="currentUser.id" [name]="currentUser.firstName" size="medium"></dix-avatar>
							<div class="profile-menu-info min-w-0">
								<div class="profile-menu-name fw-medium">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
								<div class="profile-menu-email">{{ currentUser.email }}</div>
							</div>
						</div>
						<mat-divider></mat-divider>
						<button mat-menu-item (click)="changePassword()">
							<mat-icon>manage_accounts</mat-icon>
							Change Password
						</button>
						<button mat-menu-item (click)="editProfile()">
							<mat-icon>edit</mat-icon>
							Edit Profile
						</button>
						<button mat-menu-item (click)="logout()">
							<mat-icon>logout</mat-icon>
							Logout
						</button>
					</mat-menu>
				</div>
			}
		</div>

		@if (!sideNav.isCollapsed) {
			<div class="panel overflow-x-hidden d-flex flex-column">
				@if (clients$ | async; as clients) {
					@if (shouldShowClientSelector()) {
						<mat-form-field appearance="outline" class="workspace-field w-100 px-2 pt-2">
							<mat-label>Workspace</mat-label>
							<mat-select
								(selectionChange)="onClientChange($event.value)"
								[value]="vm?.activeClient?.id"
								[disabled]="clients.length <= 1"
							>
								@for (client of clients; track client.id) {
									<mat-option [value]="client.id">
										{{ client.name ? (client.state ? client.name + ', ' + client.state : client.name) : client.id }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
				}

				<div class="panel-title fw-super-bold text-uppercase">{{ getSelectedToolLabel() }}</div>

				<div class="links overflow-y-auto flex-fill">
					@if (sideNav.selectedTool === NavTool.Finance) {
						<dix-scenario-nav />
					}

					@for (section of vm?.sectionsForSelectedTool ?? []; track $index) {
						@if (section.label) {
							<div class="nav-section-label">{{ section.label }}</div>
						}
						<ul>
							@for (page of section.pages; track page.label) {
								<li>
									<a
										[routerLink]="pageRoute(page)"
										routerLinkActive="active"
										[routerLinkActiveOptions]="routerLinkActiveOptions"
									>
										@if (page.icon) {
											<mat-icon>{{ page.icon }}</mat-icon>
										}
										<span>{{ page.label }}</span>
									</a>
								</li>
							}
						</ul>
					}
				</div>
			</div>
		}
	</div>
</div>
